import { render, staticRenderFns } from "./management.vue?vue&type=template&id=b2c0b80a&"
import script from "./management.vue?vue&type=script&lang=js&"
export * from "./management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports